import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY

export const getUnidades = (setData) => {
    api.get(`${urlApi}/instalacion/routesStatus`)
        .then((res) => {
            setData(res.data)
        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getsetEquipamiento = (setData) => {
    api.get(`${urlApi}/input/get-cat-equipamiento`)
        .then((res) => {
            setData(res.data)
        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getTecnicos = (setData) => {
    api.get(`${urlApi}/input/get-tecnico`)
        .then((res) => {
            setData(res.data)
        })
        .catch((error) => {
            console.log("error", error);

        })
}
export const addCardex = (data) => {
    Swal.fire({
        title: 'Subiendo...',
        text: 'Subiendo datos...',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    })
    api.post(`${urlApi}/administracion/instalaciones/addCardex`, data)
        .then((res) => {
            Swal.close();
        })
        .catch((error) => {
            console.log("error", error);
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Error",
                text:error
            });
        })
}
export const getHistoricoUnidad = (id_unidad,setDataHistorico) => {
    Swal.fire({
        title: 'Cargando...',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    })
    api.get(`${urlApi}/administracion/instalaciones/getUnitsHistory?id_unidad=${id_unidad}`)
        .then((res) => {
            setDataHistorico(res.data)
            Swal.close();
        })
        .catch((error) => {
            console.log("error", error);
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Error",
                text:error
            });
        })
}
export const getCards = (setCards) => {
    Swal.fire({
        title: 'Cargando...',
        allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
        allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
        didOpen: () => {
            Swal.showLoading();     // Muestra el spinner de carga
        }
    })
    api.get(`${urlApi}/instalacion/getCards`)
        .then((res) => {
            setCards(res.data)
            Swal.close();
        })
        .catch((error) => {
            console.log("error", error);
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Error",
                text:error
            });
        })
}